import React, { useContext, useEffect, useState } from 'react';
import {
  Tooltip,
  Avatar,
  Dropdown,
  Menu,
  Button,
  Modal,
  Space,
  Image,
  Typography,
} from '@arco-design/web-react';
import {
  IconSunFill,
  IconMoonFill,
  IconUser,
  IconSettings,
  IconPoweroff,
  IconLoading,
  IconEdit,
} from '@arco-design/web-react/icon';
import { useSelector } from 'react-redux';
import { GlobalState } from '@/store';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import IconButton from './IconButton';
import Settings from '../Settings';
import styles from './style/index.module.less';
import useStorage from '@/utils/useStorage';
import UpdateUserInfo from './updateUserInfo';
import LogoFull from '@/assets/logo-full.jpg';
import Logo from '@/assets/logo.jpg';

function Navbar({ show }: { show: boolean }) {
  const t = useLocale();
  const { userInfo, userLoading } = useSelector((state: GlobalState) => state);

  const [_, setToken] = useStorage('token');

  const [updateUserInfoVisible, setUpdateUserInfoVisible] = useState(false);

  const { theme, setTheme } = useContext(GlobalContext);

  function logout() {
    setToken('');
    window.location.href = '/login';
  }

  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    }
    if (key === 'updatePassword') {
      setUpdateUserInfoVisible(true);
    }
  }

  if (!show) {
    return (
      <div className={styles['fixed-settings']}>
        <Settings
          trigger={
            <Button icon={<IconSettings />} type="primary" size="large" />
          }
        />
      </div>
    );
  }

  const droplist = (
    <Menu onClickMenuItem={onMenuItemClick}>
      <Menu.Item key="updatePassword">
        <IconEdit className={styles['dropdown-icon']} />
        修改密码
      </Menu.Item>
      <Menu.Item key="logout">
        <IconPoweroff className={styles['dropdown-icon']} />
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={styles.navbar}>
      <div className={styles.left}>
        <div className={styles.logo}>
          <Typography.Title heading={5} style={{ marginTop: 20 }}>
            数字专家库·管理后台
          </Typography.Title>
          {/* <Image src={LogoFull} alt="logo" width={200} preview={false} /> */}
        </div>
      </div>
      <ul className={styles.right}>
        <li>
          <Tooltip
            content={
              theme === 'light'
                ? t['settings.navbar.theme.toDark']
                : t['settings.navbar.theme.toLight']
            }
          >
            <IconButton
              icon={theme !== 'dark' ? <IconMoonFill /> : <IconSunFill />}
              onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
            />
          </Tooltip>
        </li>
        {/* <Settings /> */}
        {userInfo && (
          <li>
            <Dropdown droplist={droplist} position="br" disabled={userLoading}>
              <Space style={{ cursor: 'pointer' }}>
                <Avatar size={32}>
                  {userLoading ? <IconLoading /> : <IconUser />}
                </Avatar>
                <span
                  style={{
                    color: 'var(--color-text-1)',
                  }}
                >
                  {userInfo.nickname}
                </span>
              </Space>
            </Dropdown>
          </li>
        )}
      </ul>
      <Modal
        title={'修改密码'}
        visible={updateUserInfoVisible}
        footer={null}
        style={{ width: 800 }}
        unmountOnExit
        maskClosable={false}
        focusLock={false}
        onCancel={() => {
          setUpdateUserInfoVisible(false);
        }}
      >
        <UpdateUserInfo
          onClose={() => {
            setUpdateUserInfoVisible(false);
          }}
          onSuccess={() => {
            setUpdateUserInfoVisible(false);
            logout();
          }}
        />
      </Modal>
    </div>
  );
}

export default Navbar;
